import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'PayResponseService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$stateParams'
];

class PayResponseController{
  constructor ($scope, PayResponseService, $state, $rootScope, SharedService, $uibModal, $stateParams) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.$stateParams = $stateParams;
    this.PayResponseService = PayResponseService;
    this.SharedService = SharedService;
    this.loanding = false;
    this.payInfo = {};
  }

  $onInit(){
    this.getResponse();
  }
  
  getResponse() {
    this.PayResponseService.getResponse(this.$stateParams.idPay).then(({data}) => {


      this.payInfo = data;
      this.payInfo.Info = this.payInfo.estado_transaccion == 1?"Su Transacción se Realizó Exitosamente":(this.payInfo.estado_transaccion == 0?"Su Transacción se Realizó Exitosamente":"Su Transacción ha sido rechazada por la pasarela de pagos");
      this.payInfo.Summary = this.payInfo.estado_transaccion == 1?"cuyo pago está siendo procesado, pronto le enviaremos un email de confirmación del pago.":(this.payInfo.estado_transaccion == 0?"cuyo pago está siendo procesado, pronto le enviaremos un email de confirmación del pago.":"");
      this.payInfo.fa = this.payInfo.estado_transaccion == 1?"fa fa-check-square-o":(this.payInfo.estado_transaccion == 0?"fa fa-check-square-o":"fa fa-times-circle");

      this.getPaymentDetail();
    }).catch(reason => {
    
    })
  }
  

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }

  getPaymentDetail(){
    this.PayResponseService.getPaymentDetail(this.$stateParams.idPay).then((response) => {
      this.payInfo.facturas = response;
      console.log(this.payInfo.facturas.facturas);
    }).catch(reason => {
    
    })



  }
}

PayResponseController.$inject = inject;

export default PayResponseController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/response/response.controller.js
 **/